module.exports = __webpack_public_path__ + "static/media/upright.826a98a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/pics/img/upright.jpg
// module id = 91
// module chunks = 0